import React, { useEffect, useRef } from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonNote,
  IonSpinner,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { Controller, useForm } from "react-hook-form";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { useDispatch, useSelector } from "react-redux";

import { chevronBack } from "ionicons/icons";

import updateDocument from "../../../store/documentUpdate/actions/updateDocument";

import { resetUpdatedDocument, setUpdatedDocument } from "../../../store/documentUpdate";

import updateArchive from "../../../store/documentUpdate/actions/updateArchive";

import { selectUpdatedDocument } from "../../../store/documentUpdate/selectors/selectUpdatedDocument";
import { selectUpdateArchiveStatus } from "../../../store/documentUpdate/selectors/selectUpdateArchiveStatus";
import { selectShowUpdateArchiveModal } from "../../../store/documentShow/selectors/selectShowUpdateArchiveModal";
import { setShowUpdateArchiveModal } from "../../../store/documentShow";

export const ModalUpdateArchive: React.FC = () => {
  const [presentToast] = useIonToast();
  const showModal = useSelector(selectShowUpdateArchiveModal);
  const newDocument = useSelector(selectUpdatedDocument);
  const updateArchiveStatus = useSelector(selectUpdateArchiveStatus);
  const fileInput = useRef(null);

  const dispatch = useDispatch();

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: { ...newDocument },
  });

  useEffect(() => {
    dispatch(resetUpdatedDocument());
  }, [dispatch]);

  const onSubmit = async (data: any) => {
    try {
      dispatch(setUpdatedDocument(data));
      await dispatch(updateDocument());
      dispatch(setShowUpdateArchiveModal(false));
      presentToast({
        message: `Se actualizó correctamente el documento del acuerdo`,
        color: "success",
        duration: 8000,
      });
    } catch (error) {}
  };

  const onFilechange = async (event: any) => {
    dispatch(updateArchive(event.target.files[0]));
  };

  const docFormSubmit: any = useRef(null);

  return (
    <>
      <IonModal isOpen={showModal} onDidDismiss={() => dispatch(setShowUpdateArchiveModal(false))}>
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => dispatch(setShowUpdateArchiveModal(false))}>
                <IonIcon icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>Actualizar archivo</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent class="ion-padding">
          <form noValidate onSubmit={handleSubmit(onSubmit)}>
            <IonItem
              lines="inset"
              onClick={() => {
                // @ts-ignore
                fileInput?.current?.click();
              }}
            >
              <IonLabel position="stacked">Archivo</IonLabel>
              <Controller
                name="archiveFilename"
                control={control}
                render={({ }) => (
                  <>
                    <input
                      ref={fileInput}
                      type="file"
                      accept="application/pdf"
                      onChange={onFilechange}
                      name="archive"
                      required
                      hidden
                    />

                    <IonInput
                      value={newDocument.archive?.filename}
                      placeholder="Ingrese el archivo"
                      {...register("archiveFilename", {
                        required: "Campo obligatorio.",
                      })}
                      readonly
                    />
                  </>
                )}
              />
              <IonNote slot="end">
                {updateArchiveStatus === "pending" && <span>Subiendo</span>}
              </IonNote>
            </IonItem>
            <InputErrorMessage errorMessage={errors.archiveFilename?.message || ""} />

            <br />

            <IonButton
              ref={docFormSubmit}
              fill="solid"
              type="submit"
              style={{ display: "none" }}
            ></IonButton>
          </form>
        </IonContent>
        <IonFooter style={{ display: "flex" }} class="ion-padding-end">
          <span style={{ display: "flex", flex: 1 }}></span>
          <IonButton
            fill="solid"
            onClick={() => docFormSubmit.current.click()}
            disabled={updateArchiveStatus === "pending"}
          >
            {updateArchiveStatus === "pending" ? (
              <>
                <IonSpinner />
                <span className="ion-margin-start">Actualizando acuerdo</span>
              </>
            ) : (
              <>Actualizar archivo</>
            )}
          </IonButton>
        </IonFooter>
      </IonModal>
    </>
  );
};
